import React from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import AuthService from '../../../business-api/AuthService'

import {
    adicionaNaoInformar
} from '../../../business-components/Array/Array'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem2,
    GridItem2xs6,
    GridItem3xs10,
    GridItem4xs12,
    GridItem5xs12,
    GridItem8xs10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    DateTimePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    dataAtual,
} from '../../../business-components/Date/Date'

import {
    sortDesc
} from '../../../business-components/Sort/Sort'

import {
    equipeListCompartilhamento,
} from '../compartilhamento-form/CompartilhamentoService'

import {
    incrementaContPendencia,
} from './AcompanhamentoServicePendencias'



const Observacao = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`pendencias[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
            disabled={values.ultimaVersao !== values.versao}
        />
    )
}



const AcompanhamentoFormPendencias = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars }) => {

    useSingleton(async () => {

        if (values.pendencias) {

            values.pendencias = sortDesc(values.pendencias)
        }

    })



    const isXsDownScreen = IsXsDownScreen()
    


    return (

        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem12>
                    <FieldArray name="pendencias">
                        {(arrayHelpers) => (
                            <CardGridEntradaDados>
                                <CardGridDivBodyEntradaDados>
                                    {vars.jsonConfiguracao &&
                                    vars.jsonConfiguracao.tipoPendencia && 
                                    vars.jsonConfiguracao.tipoPendencia.length > 0
                                        ?
                                            <>
                                                <DivForm
                                                    className='mt-2'
                                                >
                                                    {values.pendencias?.map((item, ind) => {

                                                        return (
                                                            <GridContainer
                                                                key={ind}
                                                            >
                                                                <GridItem12>
                                                                    <GridContainer>
                                                                        <GridItem2xs6>
                                                                            <MuiPickersUtilsProviderPadrao>
                                                                                <DateTimePickerPadrao
                                                                                    name={`pendencias[${ind}].dataHoraInclusao`}
                                                                                    label={LABEL.dataHoraInclusao}
                                                                                    value={item.dataHoraInclusao}
                                                                                    onChange={(date) =>
                                                                                        setFieldValue(
                                                                                            `pendencias[${ind}].dataHoraInclusao`,
                                                                                            date
                                                                                        )
                                                                                    }
                                                                                    disabled={true}
                                                                                />
                                                                            </MuiPickersUtilsProviderPadrao>
                                                                        </GridItem2xs6>

                                                                        <GridItem4xs12>
                                                                            <TextFieldTextSelect
                                                                                name={`pendencias[${ind}].tipoPendencia`}
                                                                                label={LABEL.tipoPendencia}
                                                                                value={item.tipoPendencia || ''}
                                                                                onChange={handleChange}
                                                                                list={
                                                                                    vars.jsonConfiguracao.tipoPendencia
                                                                                        .filter(tipoPendencia =>
                                                                                            tipoPendencia.id === item.tipoPendencia
                                                                                            ||
                                                                                            tipoPendencia.ativo !== 'N'
                                                                                        )
                                                                                }
                                                                                disabled={values.ultimaVersao !== values.versao}
                                                                            />
                                                                        </GridItem4xs12>

                                                                        <GridItem2xs6>
                                                                            <MuiPickersUtilsProviderPadrao>
                                                                                <KeyboardDatePickerPadrao
                                                                                    name={`pendencias[${ind}].dataPrevista`}
                                                                                    label={LABEL.dataPrevista}
                                                                                    value={item.dataPrevista}
                                                                                    onChange={(date) =>
                                                                                        setFieldValue(
                                                                                            `pendencias[${ind}].dataPrevista`,
                                                                                            date
                                                                                        )
                                                                                    }
                                                                                    disabled={values.ultimaVersao !== values.versao}
                                                                                />
                                                                            </MuiPickersUtilsProviderPadrao>
                                                                        </GridItem2xs6>

                                                                        <GridItem2xs6>
                                                                            <MuiPickersUtilsProviderPadrao>
                                                                                <KeyboardDatePickerPadrao
                                                                                    name={`pendencias[${ind}].dataResolucao`}
                                                                                    label={LABEL.dataResolucao}
                                                                                    value={item.dataResolucao}
                                                                                    onChange={(date) =>
                                                                                        setFieldValue(
                                                                                            `pendencias[${ind}].dataResolucao`,
                                                                                            date
                                                                                        )
                                                                                    }
                                                                                    disabled={values.ultimaVersao !== values.versao}
                                                                                />
                                                                            </MuiPickersUtilsProviderPadrao>
                                                                        </GridItem2xs6>
                                                                    </GridContainer>

                                                                    <GridContainer>
                                                                        {!isXsDownScreen && (
                                                                            <GridItem2/>
                                                                        )}

                                                                        {vars.jsonConfiguracao.habilitaCompartilhamentoClientes &&
                                                                        !AuthService.obterAcessoCliente(variaveisGlobais)/* && 
                                                                        vars.jsonConfiguracao.compartilhamentoPerfilUsuario*/
                                                                            ?
                                                                                <>
                                                                                    <GridItem5xs12>
                                                                                        <Observacao
                                                                                            values={values}
                                                                                            item={item}
                                                                                            ind={ind}
                                                                                            handleChange={handleChange}
                                                                                        />
                                                                                    </GridItem5xs12>

                                                                                    <GridItem3xs10>
                                                                                        <TextFieldTextSelect
                                                                                            name={`pendencias[${ind}].idUsuarioDelegar`}
                                                                                            label={LABEL.delegar}
                                                                                            value={item.idUsuarioDelegar || ''}
                                                                                            onChange={handleChange}
                                                                                            list={
                                                                                                adicionaNaoInformar(
                                                                                                    equipeListCompartilhamento(
                                                                                                        variaveisGlobais, values,
                                                                                                            item.idUsuarioDelegar,
                                                                                                                vars.perfil,
                                                                                                                    vars.jsonConfiguracao,
                                                                                                                        vars.equipeList
                                                                                                    )
                                                                                                )
                                                                                            }
                                                                                            disabled={values.ultimaVersao !== values.versao}
                                                                                        />
                                                                                    </GridItem3xs10>
                                                                                </>
                                                                            :
                                                                                <GridItem8xs10>
                                                                                    <Observacao
                                                                                        values={values}
                                                                                        item={item}
                                                                                        ind={ind}
                                                                                        handleChange={handleChange}
                                                                                    />
                                                                                </GridItem8xs10>
                                                                        }

                                                                        <GridItem2>
                                                                            {values.ultimaVersao === values.versao && (
                                                                                <IconButtonClearEntradaDados
                                                                                    onClick={() =>
                                                                                        arrayHelpers.remove(ind)
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </GridItem2>
                                                                    </GridContainer>
                                                                </GridItem12>
                                                            </GridContainer>
                                                        )
                                                    })}
                                                </DivForm>

                                                {values.ultimaVersao === values.versao && (
                                                    <ButtonIncluirLinha
                                                        label={LABEL.buttonIncluirPendencia} 
                                                        onClick={() => 
                                                            {
                                                                incrementaContPendencia(values)
                                                                arrayHelpers.push({
                                                                    id: values.contPendencia,
                                                                    dataPrevista: null,
                                                                    dataResolucao: null,
                                                                    ordem: values.contPendencia,
                                                                    dataHoraInclusao: dataAtual(),
                                                                })
                                                            }
                                                        }
                                                    />
                                                )}
                                            </>
                                        :
                                            <h5>
                                                <br/>
                                                {MESSAGE().orientacaoConfiguracaoPendencias}
                                                <br/>
                                                <br/>
                                            </h5>
                                    }
                                </CardGridDivBodyEntradaDados>
                            </CardGridEntradaDados>
                        )}
                    </FieldArray>
                </GridItem12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default AcompanhamentoFormPendencias